import { render, staticRenderFns } from "./ProdRoundSku.vue?vue&type=template&id=0ed86906&"
import script from "./ProdRoundSku.vue?vue&type=script&lang=js&"
export * from "./ProdRoundSku.vue?vue&type=script&lang=js&"
import style0 from "./ProdRoundSku.vue?vue&type=style&index=0&id=0ed86906&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports